/**
 * Contract for staff-to-staff direct messages (SPEC.md §5.3, decision D29).
 *
 * Distinct from the per-ticket thread in `ticket.ts`. That one is part of a job's
 * record; this one belongs to two people and to no job.
 */
import { z } from 'zod';
/**
 * Body of POST /api/messages/conversations — open a thread with someone, or find the
 * one that already exists.
 *
 * Idempotent by design: asking twice returns the same conversation rather than a
 * second one. Two threads with the same person is the failure mode that makes a DM
 * feature useless, because half your history is in the other one.
 */
export const startConversationBodySchema = z.object({
    userId: z.string().min(1),
});
/** Body of POST /api/messages/conversations/:id. */
export const sendDirectMessageBodySchema = z.object({
    // Trimmed first, so a message of only spaces is rejected rather than stored blank.
    body: z.string().trim().min(1).max(4000),
});
export const directMessagePayloadSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    body: z.string(),
    /** Null once the sender's account has been deleted (D25). */
    senderId: z.string().nullable(),
    senderName: z.string(),
    createdAt: z.string(),
});
//# sourceMappingURL=messaging.js.map